<div  cdkDrag 
      cdkDragLockAxis="y"  
      class="drag-box cdk-drop-list-dragging full-width position-relative" 

>

  <div class="border-gray flex-column full-width padding-standard padding-none-bottom">
    <div class="flex-row flex--align-start">

      <div #handleWrapper>

        <div cdkDragHandle class="drag-handle position-relative primary-background-A200-transparent border-radius-small border-gray">

          <div class="absolute-centered">
            <mat-icon *ngIf="dragModeSubject | async;else orderIdx" class="drag-icon">drag_indicator</mat-icon>
          
            
            <ng-template #orderIdx>
              <div class=" mat-headline-6 margin-none " >
                {{ activity.orderIndex + 1 }}
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div  ssCoreLoaderOutlet
            class="flex-row full-stretch flex__align-center" 
            [keys]="['activity.remove.'+this.activityId]"
            
      >
        

        <ss-actor class="full-width" [suffixTemplate]="suffix"></ss-actor>

        <ng-template #suffix>
          <button type="button" mat-icon-button color="warn" (click)="removeActivity()">
            <mat-icon color="warn" >delete</mat-icon>
          </button>
        </ng-template>
        
      </div>


      <div *ngIf="splugInfoOpenedSubject | async" class="activity-splug-container" 
          [ngStyle]="{
            height: (splugInfoOpenedSubject | async) ? 'auto' : '0rem'
          }">
        <ss-actor-splug-info></ss-actor-splug-info>
      </div>
    </div>

    <p *ngIf="(showErrorObs | async)" class="warn-text" >{{'ss-process-wizard.actor-no-splugs' | translate}}</p>
  </div>

  <div *cdkDragPreview>
    <ss-activity-item class="opacity-75"  [activity]="activity" [activityId]="activityIdSubject | async"></ss-activity-item>
  </div>
  
  <div *cdkDragPlaceholder>
  
    <ss-activity-item  [activity]="activity" [activityId]="activityIdSubject | async"></ss-activity-item>
  </div>
  
  
</div>


 